// extracted by mini-css-extract-plugin
export default {"mainFooterLinks":"MainFooterLinksList_mainFooterLinks__YpuPr"};